module.exports = [
  { id: '1', abbreviation: 'AL', value: 'Alabama' },
  { id: '52', abbreviation: 'AK', value: 'Alaska' },
  { id: '2', abbreviation: 'AZ', value: 'Arizona' },
  { id: '3', abbreviation: 'AR', value: 'Arkansas' },
  { id: '4', abbreviation: 'CA', value: 'California' },
  { id: '5', abbreviation: 'CO', value: 'Colorado' },
  { id: '6', abbreviation: 'CT', value: 'Connecticut' },
  { id: '7', abbreviation: 'DE', value: 'Delaware' },
  { id: '9', abbreviation: 'FL', value: 'Florida' },
  { id: '10', abbreviation: 'GA', value: 'Georgia' },
  { id: '11', abbreviation: 'HI', value: 'Hawaii' },
  { id: '12', abbreviation: 'ID', value: 'Idaho' },
  { id: '13', abbreviation: 'IL', value: 'Illinois' },
  { id: '14', abbreviation: 'IN', value: 'Indiana' },
  { id: '15', abbreviation: 'IA', value: 'Iowa' },
  { id: '16', abbreviation: 'KS', value: 'Kansas' },
  { id: '17', abbreviation: 'KY', value: 'Kentucky' },
  { id: '18', abbreviation: 'LA', value: 'Louisiana' },
  { id: '21', abbreviation: 'ME', value: 'Maine' },
  { id: '20', abbreviation: 'MD', value: 'Maryland' },
  { id: '19', abbreviation: 'MA', value: 'Massachusetts' },
  { id: '22', abbreviation: 'MI', value: 'Michigan' },
  { id: '23', abbreviation: 'MN', value: 'Minnesota' },
  { id: '24', abbreviation: 'MS', value: 'Mississippi' },
  { id: '25', abbreviation: 'MO', value: 'Missouri' },
  { id: '26', abbreviation: 'MT', value: 'Montana' },
  { id: '27', abbreviation: 'NE', value: 'Nebraska' },
  { id: '28', abbreviation: 'NV', value: 'Nevada' },
  { id: '29', abbreviation: 'NH', value: 'New Hampshire' },
  { id: '30', abbreviation: 'NJ', value: 'New Jersey' },
  { id: '31', abbreviation: 'NM', value: 'New Mexico' },
  { id: '32', abbreviation: 'NY', value: 'New York' },
  { id: '33', abbreviation: 'NC', value: 'North Carolina' },
  { id: '34', abbreviation: 'ND', value: 'North Dakota' },
  { id: '35', abbreviation: 'OH', value: 'Ohio' },
  { id: '36', abbreviation: 'OK', value: 'Oklahoma' },
  { id: '37', abbreviation: 'OR', value: 'Oregon' },
  { id: '38', abbreviation: 'PA', value: 'Pennsylvania' },
  { id: '39', abbreviation: 'PR', value: 'Puerto Rico' },
  { id: '40', abbreviation: 'RI', value: 'Rhode Island' },
  { id: '41', abbreviation: 'SC', value: 'South Carolina' },
  { id: '42', abbreviation: 'SD', value: 'South Dakota' },
  { id: '43', abbreviation: 'TN', value: 'Tennessee' },
  { id: '44', abbreviation: 'TX', value: 'Texas' },
  { id: '53', abbreviation: 'VI', value: 'U.S. Virgin Islands' },
  { id: '45', abbreviation: 'UT', value: 'Utah' },
  { id: '47', abbreviation: 'VT', value: 'Vermont' },
  { id: '46', abbreviation: 'VA', value: 'Virginia' },
  { id: '48', abbreviation: 'WA', value: 'Washington' },
  { id: '8', abbreviation: 'DC', value: 'Washington DC' },
  { id: '50', abbreviation: 'WV', value: 'West Virginia' },
  { id: '49', abbreviation: 'WI', value: 'Wisconsin' },
  { id: '51', abbreviation: 'WY', value: 'Wyoming' },
];
